var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _path12, _path13, _path14, _path15, _path16, _g2, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _g3, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _g4, _g5, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _g6, _g7, _circle, _path59, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoactioncar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_228",
    "data-name": "Group 228",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 119.275,
    height: 199.973,
    viewBox: "0 0 119.275 199.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -211.713,
    y1: 0.975,
    x2: -211.008,
    y2: 0.025,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#eceef7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9c9aa8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -301.914,
    y1: 0.812,
    x2: -302.41,
    y2: 0.235,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#393843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#23222e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -898.031,
    y1: 0.441,
    x2: -899.214,
    y2: 0.585,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#adaeb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.076,
    stopColor: "#babbc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#c9cbd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342,
    stopColor: "#d2d4dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#d5d7df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#c0c1ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868490"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -722.671,
    y1: 0.568,
    x2: -723.44,
    y2: 0.435,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -368.374,
    y1: 0.721,
    x2: -368.601,
    y2: 0.198,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -223.392,
    y1: 0.975,
    x2: -222.687,
    y2: 0.025,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -318.577,
    y1: 0.812,
    x2: -319.073,
    y2: 0.235,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -947.427,
    y1: 0.441,
    x2: -948.611,
    y2: 0.585,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -762.384,
    y1: 0.568,
    x2: -763.154,
    y2: 0.435,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -388.714,
    y1: 0.721,
    x2: -388.941,
    y2: 0.198,
    xlinkHref: "#linear-gradient-3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190",
    transform: "translate(0 112.837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M175.862,373.991l64.652,37.7a39.714,39.714,0,0,0,13.154,3.767c6.547.43,12.236-2.484,16.211-4.3S283,404.077,284.9,402.3s7.108-5.523,1.956-10.573S204.871,347.282,198.039,347s-27.656,17.2-28.182,20.234C169.357,370.132,172.013,371.769,175.862,373.991Z",
    transform: "translate(-169.797 -328.364)",
    opacity: 0.29
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M280.057,396.795l-2.113-.21s-8.814,6.1-15.907,8.874.933-3.319,3.217-4.881,14.438-7.459,14.8-6.516A6.416,6.416,0,0,1,280.057,396.795Z",
    transform: "translate(-166.44 -326.6)",
    fill: "#9099af"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M180.14,368.4l6.031-3.935,16.517,10.819,32.214,25.38,4.224-3.587,13.789,8.2.906-24.307L180.14,349.538S173.943,353.117,180.14,368.4Z",
    transform: "translate(-169.512 -328.269)",
    fill: "#131313"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M197.913,371.949c0,4.088-2.889,5.736-6.453,3.678a14.218,14.218,0,0,1-6.452-11.129c0-4.089,2.889-5.736,6.452-3.679A14.216,14.216,0,0,1,197.913,371.949Z",
    transform: "translate(-169.225 -327.878)",
    fill: "#333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M191.933,378.487l4.181-2.414-9.183-15.7-4.206,2.428Z",
    transform: "translate(-169.311 -327.862)",
    fill: "#333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M193.839,374.3c0,4.09-2.889,5.738-6.453,3.679a14.216,14.216,0,0,1-6.452-11.129c0-4.089,2.889-5.737,6.452-3.678A14.214,14.214,0,0,1,193.839,374.3Z",
    transform: "translate(-169.378 -327.79)",
    fill: "#3e3e3e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M250.693,402.42c0,4.09-2.889,5.737-6.453,3.679a14.216,14.216,0,0,1-6.452-11.129c0-4.089,2.889-5.737,6.452-3.678A14.214,14.214,0,0,1,250.693,402.42Z",
    transform: "translate(-167.243 -326.733)",
    fill: "#333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M244.713,408.959l4.181-2.412-9.183-15.705-4.205,2.429Z",
    transform: "translate(-167.329 -326.717)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    transform: "translate(2.944)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M261.131,361.4a2.454,2.454,0,0,0,.078.7c0,.011.005.017.005.026a.443.443,0,0,0,.1.171.925.925,0,0,0,.123.1,2.3,2.3,0,0,0,.959.424,1.743,1.743,0,0,0,.467.022h.005a.276.276,0,0,0,.088-.01h.005a1.548,1.548,0,0,0,.517-.161c.037-.021.079-.042.12-.067h.005c.042-.021.082-.048.123-.073,0,0,.006,0,.006-.005a6.11,6.11,0,0,0,2.072-2.181,2.1,2.1,0,0,0,.134-.358,2.566,2.566,0,0,0,.088-.45.853.853,0,0,0,.01-.109,2.993,2.993,0,0,0,.021-.362,2.147,2.147,0,0,0-.01-.265.789.789,0,0,0-.016-.156,2.5,2.5,0,0,0-.093-.492.042.042,0,0,0-.005-.016,1.527,1.527,0,0,0-.435-.793.737.737,0,0,0-.606-.166,7.523,7.523,0,0,0-2.518,1.367,3.064,3.064,0,0,0-1.17,1.535l-.017.047a1.612,1.612,0,0,0-.035.262c0,.12-.01.259-.016.4v.005C261.131,361,261.126,361.2,261.131,361.4Z",
    transform: "translate(-169.31 -327.982)",
    fill: "#eeeef0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M262.12,360.9v.17l0,.005a.055.055,0,0,0,0,.036,2.664,2.664,0,0,0,.187,1.005v.005l.005.005a.891.891,0,0,0,.44.5.971.971,0,0,0,.8-.047v0a1.161,1.161,0,0,0,.135-.062s.006,0,.006-.005a4.736,4.736,0,0,0,2.072-2.181,2.092,2.092,0,0,0,.134-.358,2.02,2.02,0,0,0,.088-.42v-.03a.856.856,0,0,0,.01-.109,3.005,3.005,0,0,0,.021-.362,2.151,2.151,0,0,0-.01-.264.616.616,0,0,0-.01-.14v0a2,2,0,0,0-.1-.5.043.043,0,0,0-.005-.016c-.078-.217-.187-.342-.3-.363a.847.847,0,0,0-.249.01,4.041,4.041,0,0,0-1.679.819A3.155,3.155,0,0,0,262.12,360.9Z",
    transform: "translate(-169.273 -327.96)",
    fill: "#efeef0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(30.417 0.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M287.128,393.38a1.876,1.876,0,0,1-1.238.414c-.571-.111-4.86-2.6-4.86-2.6l-.219-.118v-1.894a16.266,16.266,0,0,0-7.381-12.731c-3.291-1.9-6.078-1.039-7.031,1.825a7.563,7.563,0,0,0-.351,2.383v2.515l-.62-.332L226.048,360.1V357.56a12.534,12.534,0,0,0-.56-3.562,16.425,16.425,0,0,0-6.821-9.168c-4.077-2.354-7.381-.469-7.381,4.207v1.611l-7.357-5.8-1.262-3.242v-1.475l.262-.531V338.5l-.43-.548-.55-1.568.976-1.294s.166-2.635.285-3.278a4.918,4.918,0,0,1,.211-1.7v0a3.167,3.167,0,0,1,.883-.8.3.3,0,0,1,.1.013c.713.174,6.249,1.929,6.249,1.929s1.143.223,3.27.541,8.886.767,10.664,1.319a98.581,98.581,0,0,1,15.492,7.924,57.725,57.725,0,0,1,10.668,8c4.835,4.486,13.047,13.34,14.127,14.657,1.9,1.463,17.335,11.772,19.4,16.645.476,1.4,1.586,5.76,1.586,5.76l.857,1.514v.985l-.539.745.382,2.66Z",
    transform: "translate(-201.95 -329.306)",
    fill: "#e7e7e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M287.128,393.211a1.876,1.876,0,0,1-1.238.414c-.571-.111-4.86-2.6-4.86-2.6l-.219-.118v-1.893a16.266,16.266,0,0,0-7.381-12.731c-3.291-1.9-6.078-1.039-7.031,1.825a7.563,7.563,0,0,0-.351,2.383V383l-.62-.332-39.38-22.737v-2.541a12.534,12.534,0,0,0-.56-3.562,16.426,16.426,0,0,0-6.821-9.168c-4.077-2.354-7.381-.469-7.381,4.207v1.611l-7.357-5.8-1.262-3.242v-1.475l.262-.531v-1.092l-.43-.548-.55-1.075s2.543.686,2.765.486,4.539-3.5,5.111-3.387,16.224,9.626,22.348,13.267,29.556,18.407,38.027,24.161c9.68,6.575,9.68,10.213,11.781,14.067.183.333,4.193,3.858,4.193,3.858l.382,2.66Z",
    transform: "translate(-201.95 -329.137)",
    fill: "#d2d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M215.985,339.361c-3.334-1.305-5.493.035-5.588,5.59,4.064-2.5,5.175-3.256,8.953-.085a37.089,37.089,0,0,1,6.475,7.392S224.461,342.907,215.985,339.361Z",
    transform: "translate(-201.633 -328.946)",
    fill: "#d2d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M265.547,377.456a7.563,7.563,0,0,0-.351,2.383v2.515l-.62-.332L225.2,359.286v-2.541a12.536,12.536,0,0,0-.56-3.562c.2-.733.322-1.192.322-1.192a3.712,3.712,0,0,1,.333-.188,6.817,6.817,0,0,1,5.191-.475c3,.995,29.427,18,31.38,19.428,1.418,1.038,2.385.848,3.19,4.1C265.223,375.553,265.388,376.4,265.547,377.456Z",
    transform: "translate(-201.098 -328.491)",
    fill: "#bec2d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M234.667,358.28l-6.095-1.388,2.143,2.166,30.962,18.614s-3-3.588-4.836-4.691S234.667,358.28,234.667,358.28Z",
    transform: "translate(-200.95 -328.27)",
    fill: "#efeef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M226.022,359.656v-2.541a12.535,12.535,0,0,0-.56-3.562,16.426,16.426,0,0,0-6.821-9.168c-4.077-2.354-7.381-.469-7.381,4.207V350.2l-7.357-5.8-1.262-3.242,1.286,1.3,6.125,4.259c.506-4.636,4.159-6.35,8.59-3.792a18.916,18.916,0,0,1,7.476,9.246,15.756,15.756,0,0,1,1.175,5.676v.779l37.461,22.261v-1.412a7.365,7.365,0,0,1,1.126-4.247c1.486-2.146,4.3-2.547,7.525-.685,4.777,2.758,8.65,9.438,8.65,14.921l.158.636,4.89,2.833a1.876,1.876,0,0,1-1.238.414c-.571-.111-4.86-2.6-4.86-2.6l-.219-.118v-1.894A16.266,16.266,0,0,0,273.4,376c-3.291-1.9-6.078-1.039-7.031,1.825a7.563,7.563,0,0,0-.351,2.383v2.515l-.62-.332Z",
    transform: "translate(-201.924 -328.861)",
    fill: "#9099af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M220.278,337.376c10.79,6.783,43.144,27.468,43.144,27.468s12.33,7.7,14.307,9.854,4.724,7.329,5.2,8.179a28.528,28.528,0,0,0,2.875,3.211s-1.11-4.357-1.586-5.759c-2.064-4.872-17.493-15.182-19.4-16.645-1.08-1.317-9.292-10.17-14.127-14.657a57.719,57.719,0,0,0-10.668-8,98.582,98.582,0,0,0-15.492-7.924c-1.778-.552-8.537-1-10.664-1.319s-3.27-.541-3.27-.541-5.536-1.755-6.249-1.929a10.39,10.39,0,0,1-.978.791v0A62.6,62.6,0,0,1,220.278,337.376Z",
    transform: "translate(-201.897 -329.306)",
    fill: "#efeef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M224.748,356.456c0,4.089-2.89,5.736-6.453,3.678a14.216,14.216,0,0,1-6.453-11.129c0-4.088,2.889-5.736,6.453-3.678A14.217,14.217,0,0,1,224.748,356.456Z",
    transform: "translate(-201.578 -328.738)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M223.243,355.55c0,3.169-2.239,4.444-5,2.85a11.015,11.015,0,0,1-5-8.623c0-3.17,2.238-4.446,5-2.852A11.021,11.021,0,0,1,223.243,355.55Z",
    transform: "translate(-201.526 -328.67)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M277.527,386.928c0,4.089-2.889,5.737-6.452,3.678a14.214,14.214,0,0,1-6.453-11.128c0-4.09,2.889-5.737,6.453-3.679A14.218,14.218,0,0,1,277.527,386.928Z",
    transform: "translate(-199.596 -327.593)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M276.023,386.022c0,3.168-2.239,4.445-5,2.851a11.018,11.018,0,0,1-5-8.625c0-3.169,2.239-4.444,5-2.85A11.018,11.018,0,0,1,276.023,386.022Z",
    transform: "translate(-199.543 -327.525)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(18.05 7.903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M262.432,379.5l-.2-.117c-.3-.18-30.069-18-31.983-19.13a8.585,8.585,0,0,1-3.191-3.95l-.075-.161c-.379-.8-4.669-10.881-4.851-11.31l-2.791-7.1.22-.813,3.5.444.028.017,36.7,23.049,1.5,2.883,1.122,2.982s.466,4.069.657,5.673a52.568,52.568,0,0,1-.6,7.3ZM219.664,337.72l2.753,7c.044.1,4.469,10.505,4.843,11.295l.077.163a8.321,8.321,0,0,0,3.07,3.818c1.833,1.083,29.185,17.455,31.788,19.013a49.264,49.264,0,0,0,.573-7c-.184-1.54-.62-5.357-.655-5.656l-1.1-2.911-1.451-2.794-36.6-22.987-3.173-.4Z",
    transform: "translate(-219.347 -336.923)",
    fill: "#878788"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M276.279,374.14l4.259,2.815s.4,1.659.829,3.055.786,3.349.786,3.349-1.854-2.171-1.926-2.376-3.452-6.01-3.452-6.01Z",
    transform: "translate(-199.158 -327.622)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M202.927,331.152l2.624.616,3.971,1.657-.7.922-1.935,1.3-3.11-1.159-1.159-.859-.218-1.723Z",
    transform: "translate(-201.933 -329.237)",
    fill: "#dee0df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M209.8,346.337s-5.969-4.175-6.318-4.523-.841-.921-.841-.921v-1.158l1.857,1.537,2.286,1.867.508.839Z",
    transform: "translate(-201.924 -328.914)",
    fill: "#d2d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M283.793,385.648a10.974,10.974,0,0,1-2.491-1.309,4.42,4.42,0,0,1-1.56-2.994l3.195,2.79Z",
    transform: "translate(-199.028 -327.351)",
    fill: "#efeef0"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M214.938,331.79l-32.07,18.515-3.27-.541-4.72-2.883,30.445-17.575,6.344,1.942Z",
    transform: "translate(-172.55 -329.029)",
    fill: "#efeef0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M214.649,331.7l10.664,1.318L197.1,349.307l-14.521.908Z",
    transform: "translate(-172.26 -328.939)",
    fill: "#efeef0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M264.127,362.97,233.16,380.849,221.788,364.6,250,348.313Z",
    transform: "translate(-170.788 -328.315)",
    fill: "#efeef0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M222.735,365.178l28.213-16.288-9.026-6.538-17.134-9.381L196.575,349.26Z",
    transform: "translate(-171.735 -328.891)",
    fill: "#efeef0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M263.716,362.439l-30.967,17.879L252.7,396.645l30.417-17.561-2.279-3.618Z",
    transform: "translate(-170.376 -327.784)",
    fill: "#efeef0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M254.817,408.826l30.416-17.561.009-.586-.405-5.113L253.865,404.78l-1.476,1.075Z",
    transform: "translate(-169.638 -326.915)",
    fill: "#d2d3d4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(0 17.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M257.813,410.3a1.875,1.875,0,0,1-1.238.415c-.572-.112-6.513-1.65-6.513-1.65l-.22-.118v-1.894a16.265,16.265,0,0,0-7.381-12.731c-3.291-1.9-6.077-1.039-7.029,1.825a7.535,7.535,0,0,0-.351,2.383v2.515l-.62-.333L195.08,377.98v-2.54a12.526,12.526,0,0,0-.56-3.563,16.424,16.424,0,0,0-6.821-9.169c-4.076-2.352-7.38-.469-7.38,4.208v1.611l-6.255-6.44-1.262-3.242V357.37l.261-.531v-1.094l-.429-.548v-1.884l.976-1.295s.167-2.635.285-3.278a10.4,10.4,0,0,1,.763-2.021h0c.14-.28.265-.474.332-.487a.269.269,0,0,1,.094.014,42.191,42.191,0,0,1,4.6,2.883s1.142.222,3.269.541,12.743-1.46,14.522-.908a98.388,98.388,0,0,1,15.492,7.925,57.67,57.67,0,0,1,10.668,7.993c4.834,4.486,10.292,14.931,11.372,16.247,1.9,1.464,17.885,11.456,19.949,16.326.476,1.4,1.587,5.76,1.587,5.76l.857,1.515v.984l-.54.745.382,2.661Z",
    transform: "translate(-172.634 -346.231)",
    fill: "#e7e7e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M257.813,410.1a1.875,1.875,0,0,1-1.238.415c-.572-.112-6.513-1.65-6.513-1.65l-.22-.118v-1.893a16.265,16.265,0,0,0-7.381-12.731c-3.291-1.9-6.077-1.038-7.029,1.825a7.534,7.534,0,0,0-.351,2.383v2.515l-.62-.333L195.08,377.777v-2.54a12.527,12.527,0,0,0-.56-3.563A16.424,16.424,0,0,0,187.7,362.5c-4.076-2.352-7.38-.469-7.38,4.208v1.611l-6.255-6.44-1.262-3.242v-1.475l.261-.531v-1.094l-.429-.548V353.6s1.441,1.324,1.663,1.124,3.989-3.18,4.561-3.069,16.223,9.628,22.348,13.266,29.555,18.408,38.027,24.162c9.68,6.575,9.68,10.213,11.782,14.067a64.954,64.954,0,0,0,5.846,2.9l.382,2.661Z",
    transform: "translate(-172.634 -346.027)",
    fill: "#d2d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M234.639,395.3a7.535,7.535,0,0,0-.351,2.383V400.2l-.62-.333-39.381-22.736v-2.54a12.526,12.526,0,0,0-.56-3.563c.2-.733.323-1.192.323-1.192a3.687,3.687,0,0,1,.332-.189,6.823,6.823,0,0,1,5.191-.474c3,.994,29.428,18,31.38,19.428,1.419,1.038,2.385.848,3.192,4.1C234.315,393.4,234.479,394.249,234.639,395.3Z",
    transform: "translate(-171.842 -345.381)",
    fill: "#bec2d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M185.681,357.241c-3.333-1.305-6.712,1.847-6.807,7.4,3.058-4.507,5.46-4.633,9.59-1.938,5.452,3.558,7.513,11.221,7.513,11.221S196.776,362.213,185.681,357.241Z",
    transform: "translate(-172.4 -345.829)",
    fill: "#e7e7e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M203.759,376.124l-6.1-1.387,2.143,2.165,30.963,18.615s-3-3.588-4.837-4.692S203.759,376.124,203.759,376.124Z",
    transform: "translate(-171.694 -345.16)",
    fill: "#e7e7e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M195.074,377.524v-2.54a12.523,12.523,0,0,0-.56-3.563,16.424,16.424,0,0,0-6.821-9.169c-4.076-2.352-7.38-.469-7.38,4.208v1.611l-4.8-4.284-1.454-2.156-1.262-3.242,1.857,2.869,4.45,3.329c.506-4.636,4.16-6.351,8.59-3.791a18.9,18.9,0,0,1,7.476,9.244,15.744,15.744,0,0,1,1.176,5.676v.779L233.8,398.756v-1.412a7.365,7.365,0,0,1,1.126-4.247c1.485-2.145,4.3-2.547,7.524-.685,4.778,2.758,8.65,9.438,8.65,14.921l.158.637s4,1.876,6.343,1.784c.288-.011-.454.5-1.036.507-2.575.013-6.513-1.65-6.513-1.65l-.22-.118V406.6a16.265,16.265,0,0,0-7.381-12.731c-3.291-1.9-6.077-1.039-7.029,1.825a7.535,7.535,0,0,0-.351,2.383v2.515l-.62-.333Z",
    transform: "translate(-172.628 -345.774)",
    fill: "#9099af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M189.29,355.255c10.79,6.784,43.144,27.467,43.144,27.467s12.33,7.7,14.306,9.855a71.22,71.22,0,0,1,5.9,8.6c.476.849,3.83,1.836,3.83,1.836s-1.111-4.357-1.587-5.761c-2.064-4.87-18.044-14.862-19.949-16.326-1.08-1.317-6.538-11.761-11.372-16.247a57.663,57.663,0,0,0-10.668-7.993,98.37,98.37,0,0,0-15.492-7.925c-1.778-.552-12.395,1.225-14.522.908s-3.269-.541-3.269-.541a42.189,42.189,0,0,0-4.6-2.883c-.268.284-.412.457-.426.473h0S180.943,350.007,189.29,355.255Z",
    transform: "translate(-172.561 -346.231)",
    fill: "#efeef0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(8.613 16.658)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M193.839,374.3c0,4.09-2.889,5.738-6.452,3.679a14.214,14.214,0,0,1-6.453-11.129c0-4.089,2.889-5.736,6.453-3.678A14.217,14.217,0,0,1,193.839,374.3Z",
    transform: "translate(-180.935 -362.286)",
    fill: "#2d2c37"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M193.839,374.3c0,4.09-2.889,5.738-6.452,3.679a14.214,14.214,0,0,1-6.453-11.129c0-4.089,2.889-5.736,6.453-3.678A14.217,14.217,0,0,1,193.839,374.3Z",
    transform: "translate(-180.935 -362.286)",
    fill: "#393843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M193.433,374.212c0,3.933-2.779,5.518-6.207,3.539a13.677,13.677,0,0,1-6.207-10.706c0-3.933,2.779-5.519,6.207-3.539A13.676,13.676,0,0,1,193.433,374.212Z",
    transform: "translate(-180.932 -362.272)",
    fill: "#2d2c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M192.523,373.68c0,3.35-2.367,4.7-5.285,3.015a11.648,11.648,0,0,1-5.286-9.118c0-3.349,2.367-4.7,5.286-3.013A11.648,11.648,0,0,1,192.523,373.68Z",
    transform: "translate(-180.897 -362.227)",
    fill: "#504f58"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(1.441 1.776)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M192.343,373.326c0,3.175-2.242,4.453-5.009,2.856a11.039,11.039,0,0,1-5.009-8.641c0-3.174,2.243-4.453,5.009-2.855A11.035,11.035,0,0,1,192.343,373.326Z",
    transform: "translate(-182.324 -363.998)",
    fill: "#bababe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M182.673,368.486a10.718,10.718,0,0,0,2.564,5.557c1.441,1.651,3.07,2.483,4.379,2.4a2.261,2.261,0,0,0,1.5-.661,2.013,2.013,0,0,0,.355-.446c.022-.034.044-.064.061-.1a2.5,2.5,0,0,0,.189-.39,3.988,3.988,0,0,0,.179-.571,5.124,5.124,0,0,0,.12-1.146c0-.184-.009-.372-.026-.561-.005-.1-.018-.192-.03-.287l-.026-.192c-.008-.06-.017-.121-.03-.181-.03-.179-.064-.365-.111-.55-.022-.088-.044-.175-.07-.264a1.728,1.728,0,0,0-.064-.223c-.029-.108-.064-.219-.1-.327-.026-.081-.052-.163-.081-.24a10.41,10.41,0,0,0-.438-1.033c-.034-.074-.068-.141-.1-.21-.12-.232-.245-.46-.382-.687l-.1-.167c-.064-.1-.133-.206-.2-.305a11.2,11.2,0,0,0-.845-1.11c-.155-.175-.309-.342-.468-.5-.073-.078-.15-.15-.223-.219-.022-.022-.047-.043-.069-.064-.06-.056-.123-.111-.185-.163a6.263,6.263,0,0,0-2.23-1.3,2.51,2.51,0,0,0-3.058.953c-.021.03-.043.064-.06.094a3.3,3.3,0,0,0-.3.686A5.418,5.418,0,0,0,182.673,368.486Z",
    transform: "translate(-182.313 -363.983)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M188.845,366.963l.047,1.407c.528-.043,1.051-.094,1.54-.159-.064-.1-.133-.206-.2-.305a11.2,11.2,0,0,0-.845-1.11c-.155-.175-.309-.342-.468-.5-.073-.078-.15-.15-.223-.219-.022-.022-.047-.043-.068-.064-.06-.056-.123-.111-.185-.163a6.263,6.263,0,0,0-2.23-1.3,2.509,2.509,0,0,0-3.058.953A5.059,5.059,0,0,1,188.845,366.963Z",
    transform: "translate(-182.293 -363.983)",
    fill: "#393843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M182.96,368.319a6.766,6.766,0,0,0,2.461,2.034c1.248.424,3.663,3.345,3.663,3.345l-.185-5.472C186.047,368.441,182.96,368.319,182.96,368.319Z",
    transform: "translate(-182.3 -363.839)",
    fill: "#393843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M185.371,367.515a9.182,9.182,0,0,0,2.2,4.774,6.7,6.7,0,0,0,2.127,1.689v.005a3.37,3.37,0,0,0,1.63.368.55.55,0,0,0,.115-.013,1.538,1.538,0,0,0,.348-.064,5.125,5.125,0,0,0,.12-1.145c0-.184-.009-.373-.026-.561-.005-.1-.018-.192-.03-.287l-.026-.192c-.008-.06-.017-.121-.03-.181-.03-.179-.064-.365-.111-.55-.022-.088-.044-.175-.069-.265a1.732,1.732,0,0,0-.064-.223c-.029-.108-.064-.219-.1-.327-.026-.081-.052-.163-.081-.24a10.4,10.4,0,0,0-.438-1.033c-.034-.074-.068-.141-.1-.21-.12-.232-.245-.46-.382-.687-.094-.159-.2-.316-.3-.472a11.229,11.229,0,0,0-.845-1.11c-.155-.175-.309-.342-.468-.5-.073-.078-.15-.151-.223-.219-.022-.022-.047-.043-.068-.064-.06-.056-.123-.111-.185-.163a6.262,6.262,0,0,0-2.23-1.3,2.3,2.3,0,0,0-.382.494,2.775,2.775,0,0,0-.252.587,4.241,4.241,0,0,0-.164.995A5.723,5.723,0,0,0,185.371,367.515Z",
    transform: "translate(-182.211 -363.977)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M188.87,370.091l-.117,1.1v0l.117-1.1.856-.5.622-1.274c-.094-.159-.2-.317-.3-.472a11.215,11.215,0,0,0-.845-1.11c-.155-.175-.309-.342-.468-.5-.073-.078-.15-.15-.223-.219-.022-.022-.047-.043-.068-.064-.167.1-.3.185-.313.193l1.072,1.232Z",
    transform: "translate(-182.106 -363.924)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M188.847,369.959l-.117,1.1v0l.845,2.732.378,1.231c.129.271-.253.884-.078.85a6.082,6.082,0,0,0,1.363-.725c.022-.034.044-.064.061-.1a2.507,2.507,0,0,0,.189-.39.647.647,0,0,0-.065-.2l-.1-.309-1.544-4.545-.073-.146Z",
    transform: "translate(-182.083 -363.792)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M183.9,366.006a.288.288,0,0,1,.275.031l4.1,1.736.115.066,0,2.2-.91-.523-3.4-1.332a.889.889,0,0,1-.4-.663c-.022-.48-.763-.586-.671-1A5.6,5.6,0,0,1,183.9,366.006Z",
    transform: "translate(-182.298 -363.923)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(0.525 2.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M188.086,371.827l1.781-3.661a.667.667,0,0,0-.13-.651c-.168-.229-.348-.453-.535-.669s-.38-.416-.573-.6-.391-.2-.478-.045l-1.78,3.662Z",
    transform: "translate(-182.697 -366.096)",
    fill: "#dfdfe3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M187.542,370.516l0-2.2-.115-.065-4.1-1.735c-.186-.107-.347-.053-.387.132a5.124,5.124,0,0,0-.1,1.351.887.887,0,0,0,.4.663l3.4,1.331Z",
    transform: "translate(-182.83 -366.083)",
    fill: "#dfdfe3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M190.6,375.5c.119-.094.123-.328.011-.561l-1.648-4.853-.07-.145-1.527.444.55,1.151,1.225,3.967c.127.268.364.447.541.412A2.133,2.133,0,0,0,190.6,375.5Z",
    transform: "translate(-182.659 -365.952)",
    fill: "#dfdfe3"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M246.619,404.773c0,4.089-2.889,5.736-6.453,3.679a14.22,14.22,0,0,1-6.452-11.13c0-4.088,2.889-5.736,6.452-3.679A14.219,14.219,0,0,1,246.619,404.773Z",
    transform: "translate(-170.34 -344.483)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129",
    transform: "translate(63.375 48.275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M246.619,404.773c0,4.089-2.889,5.736-6.453,3.679a14.219,14.219,0,0,1-6.452-11.13c0-4.088,2.889-5.736,6.452-3.678A14.218,14.218,0,0,1,246.619,404.773Z",
    transform: "translate(-233.715 -392.758)",
    fill: "#2d2c37"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M246.619,404.773c0,4.089-2.889,5.736-6.453,3.679a14.219,14.219,0,0,1-6.452-11.13c0-4.088,2.889-5.736,6.452-3.678A14.218,14.218,0,0,1,246.619,404.773Z",
    transform: "translate(-233.715 -392.758)",
    fill: "#393843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M246.213,404.686c0,3.933-2.779,5.517-6.207,3.538a13.675,13.675,0,0,1-6.207-10.706c0-3.935,2.779-5.518,6.207-3.539A13.679,13.679,0,0,1,246.213,404.686Z",
    transform: "translate(-233.712 -392.744)",
    fill: "#2d2c37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M245.3,404.153c0,3.349-2.366,4.7-5.285,3.013a11.646,11.646,0,0,1-5.285-9.116c0-3.349,2.367-4.7,5.285-3.013A11.642,11.642,0,0,1,245.3,404.153Z",
    transform: "translate(-233.677 -392.7)",
    fill: "#504f58"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(1.441 1.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M245.123,403.8c0,3.175-2.242,4.453-5.009,2.856a11.042,11.042,0,0,1-5.009-8.641c0-3.175,2.243-4.453,5.009-2.856A11.038,11.038,0,0,1,245.123,403.8Z",
    transform: "translate(-235.104 -394.47)",
    fill: "#bababe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M235.452,398.958a10.72,10.72,0,0,0,2.565,5.557c1.44,1.652,3.07,2.484,4.379,2.4a2.265,2.265,0,0,0,1.5-.66,2.052,2.052,0,0,0,.356-.447.819.819,0,0,0,.06-.1,2.6,2.6,0,0,0,.189-.39,3.936,3.936,0,0,0,.181-.57,5.187,5.187,0,0,0,.119-1.146c0-.185-.008-.372-.025-.561-.005-.1-.018-.193-.031-.287l-.025-.193c-.009-.06-.018-.12-.03-.181-.03-.18-.064-.364-.112-.549-.021-.09-.043-.175-.068-.266a1.83,1.83,0,0,0-.064-.223c-.03-.107-.064-.219-.1-.326-.026-.081-.052-.163-.082-.241a10.276,10.276,0,0,0-.437-1.033c-.034-.073-.068-.141-.1-.21-.12-.231-.245-.459-.382-.687-.034-.056-.07-.111-.1-.167-.064-.1-.134-.205-.2-.3a11.051,11.051,0,0,0-.846-1.11c-.155-.176-.309-.344-.467-.5-.074-.077-.15-.149-.223-.219-.022-.021-.048-.042-.068-.063-.06-.057-.125-.113-.185-.163a6.27,6.27,0,0,0-2.23-1.3,2.507,2.507,0,0,0-3.058.952.762.762,0,0,0-.06.094,3.227,3.227,0,0,0-.3.686A5.431,5.431,0,0,0,235.452,398.958Z",
    transform: "translate(-235.093 -394.455)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M241.624,397.436l.048,1.406c.527-.043,1.05-.093,1.54-.159-.064-.1-.134-.205-.2-.3a11.046,11.046,0,0,0-.846-1.11c-.155-.176-.309-.344-.467-.5-.074-.077-.15-.149-.223-.219-.022-.021-.048-.042-.069-.063-.06-.057-.124-.113-.185-.163a6.271,6.271,0,0,0-2.23-1.3,2.506,2.506,0,0,0-3.058.952A5.057,5.057,0,0,1,241.624,397.436Z",
    transform: "translate(-235.073 -394.455)",
    fill: "#393843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M235.74,398.792a6.757,6.757,0,0,0,2.461,2.033c1.247.424,3.663,3.345,3.663,3.345l-.185-5.472C238.827,398.913,235.74,398.792,235.74,398.792Z",
    transform: "translate(-235.08 -394.311)",
    fill: "#393843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M238.15,397.988a9.2,9.2,0,0,0,2.2,4.774,6.737,6.737,0,0,0,2.127,1.688v0a3.352,3.352,0,0,0,1.63.369.491.491,0,0,0,.116-.014,1.551,1.551,0,0,0,.348-.063,5.185,5.185,0,0,0,.119-1.145c0-.185-.008-.372-.025-.561-.005-.1-.018-.193-.031-.287l-.025-.193c-.009-.06-.018-.12-.03-.181-.03-.18-.064-.364-.112-.549-.021-.09-.043-.175-.069-.266a1.841,1.841,0,0,0-.064-.223c-.03-.107-.064-.219-.1-.326-.026-.081-.052-.163-.082-.241a10.3,10.3,0,0,0-.437-1.033c-.034-.073-.068-.141-.1-.21-.12-.231-.245-.459-.382-.687-.094-.158-.2-.318-.3-.471a11.056,11.056,0,0,0-.846-1.11c-.155-.176-.309-.343-.467-.5-.074-.077-.15-.149-.223-.219-.022-.021-.048-.043-.068-.063-.06-.057-.125-.113-.185-.163a6.272,6.272,0,0,0-2.23-1.3,2.2,2.2,0,0,0-.382.493,2.789,2.789,0,0,0-.253.588,4.237,4.237,0,0,0-.163.994A5.73,5.73,0,0,0,238.15,397.988Z",
    transform: "translate(-234.991 -394.45)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M241.649,400.562l-.117,1.1v0l.117-1.1.856-.5.622-1.274c-.094-.158-.2-.317-.3-.471a11.067,11.067,0,0,0-.846-1.11c-.155-.176-.309-.344-.467-.5-.074-.077-.15-.149-.223-.219-.022-.021-.048-.043-.068-.063-.167.1-.305.184-.313.192l1.071,1.233Z",
    transform: "translate(-234.886 -394.397)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M241.626,400.43l-.117,1.1v0l.845,2.731.379,1.232c.128.27-.254.884-.078.849a6.071,6.071,0,0,0,1.363-.725.82.82,0,0,0,.06-.1,2.6,2.6,0,0,0,.189-.39.615.615,0,0,0-.064-.2l-.1-.309-1.545-4.546-.073-.145Z",
    transform: "translate(-234.863 -394.265)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M236.679,396.479a.284.284,0,0,1,.276.031l4.1,1.735.115.065,0,2.2-.91-.524-3.4-1.331a.886.886,0,0,1-.4-.662c-.023-.481-.764-.586-.672-1A5.611,5.611,0,0,1,236.679,396.479Z",
    transform: "translate(-235.078 -394.396)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(0.525 2.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M240.866,402.3l1.781-3.66a.668.668,0,0,0-.129-.652q-.254-.344-.535-.668c-.189-.216-.38-.416-.574-.6s-.39-.2-.477-.045l-1.782,3.659Z",
    transform: "translate(-235.477 -396.569)",
    fill: "#dfdfe3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M240.322,400.989l0-2.2-.114-.066-4.1-1.736c-.185-.106-.347-.051-.387.132a5.142,5.142,0,0,0-.1,1.352.883.883,0,0,0,.4.664l3.4,1.331Z",
    transform: "translate(-235.61 -396.555)",
    fill: "#dfdfe3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M243.384,405.972c.119-.093.124-.328.011-.56l-1.648-4.854-.071-.146-1.526.446.55,1.15,1.224,3.967c.128.268.365.447.542.413A2.153,2.153,0,0,0,243.384,405.972Z",
    transform: "translate(-235.439 -396.424)",
    fill: "#dfdfe3"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130",
    transform: "translate(16.635 8.553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M231.492,397.256l-.134-.08c-.309-.186-30.929-18.467-32.774-19.713a11.083,11.083,0,0,1-2.123-3.865c-1.362-9.348-7.324-13.741-7.384-13.784l-.025-.018-.386-2.1,0-.013.341-2.576.721-.636,2.39.824L228.8,378.332l3.184,2.547-.661,1.149-.46,1.806a42.218,42.218,0,0,0-.313,4.845c.114,2.48.91,8.362.918,8.422Zm-42.3-37.545a21.721,21.721,0,0,1,7.42,13.867,11.129,11.129,0,0,0,2.06,3.76c1.778,1.2,30.408,18.3,32.631,19.628-.128-.951-.795-6.02-.9-8.28a42.042,42.042,0,0,1,.315-4.88l.472-1.844.6-1.046-3.076-2.462-36.66-23.021-2.291-.787-.611.541-.333,2.509Z",
    transform: "translate(-188.667 -354.474)",
    fill: "#9099af"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M174.143,347.771l.478,1.233,1.246,1.318,1.971,1.916-1.384.986-1.02-.639a3.3,3.3,0,0,1-1.344-1.652l-.252-.682-.218-1.723Z",
    transform: "translate(-172.597 -346.173)",
    fill: "#dee0df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M178.852,364.2l-5.217-5.157c-.349-.348-.84-.923-.84-.923v-1.157l.754,2.174,2.287,1.866.507.839Z",
    transform: "translate(-172.628 -345.828)",
    fill: "#d2d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M254.538,402.539a8.548,8.548,0,0,1-3.79-1.026,5.482,5.482,0,0,1-1.915-2.324l4.849,1.836Z",
    transform: "translate(-169.772 -344.242)",
    fill: "#efeef0"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M253.562,401.8l30.417-17.56-1.587-5.76-30.417,17.561Z",
    transform: "translate(-169.654 -327.181)",
    fill: "#efeef0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M253.823,404.837l30.416-17.561.539-.746v-.984l-.857-1.514L253.5,401.594l.857,1.515v.984Z",
    transform: "translate(-170.009 -327.385)",
    fill: "#efeef0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M233.708,380s2.038,1.843,4.264,1.523,7.7-2.547,15.118-6.6,11.19-8.133,11.605-9.191-1.016-2.172-1.016-2.172Z",
    transform: "translate(-170.34 -327.742)",
    fill: "#292929"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M249.381,348.645a76.234,76.234,0,0,1-9.638,6.655c-2.251,1.349-4.4,2.56-6.375,3.617-6.391,3.428-10.918,5.275-10.918,5.275l.01.013c.167.153,2.26,2.125,6.6,8.395,2.778,4.011,4.3,6.573,5.072,7.956h0a1.506,1.506,0,0,0,1.791.446c.033-.012.066-.024.1-.038l.716-.305c.057-.021.115-.046.172-.073a.678.678,0,0,0,.09-.039l.251-.106.006,0c3.91-1.694,8.345-3.931,11.884-5.83,1.974-1.056,3.669-2.008,4.84-2.7,3.485-2.063,8.147-5.221,9.744-7.232a3.845,3.845,0,0,0,.378-.558A172.044,172.044,0,0,0,249.381,348.645Z",
    transform: "translate(-170.763 -328.302)",
    fill: "#37464e"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M234.321,357.97c.63,1.133,2.2.8,2.655.516s4.34-2.48,4.925-2.928c.5-.383-.018-1.6-.18-1.939-.834.528-1.651,1.028-2.425,1.494C237.568,356.151,235.9,357.1,234.321,357.97Z",
    transform: "translate(-170.317 -328.115)",
    fill: "#131313"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M262.771,364.072l-.858.043s-8.571-5.48-18.361-11.726a56.065,56.065,0,0,0,4.961-3.683c.866.839,1.821,1.808,2.866,2.931C256.378,357.013,262.771,364.072,262.771,364.072Z",
    transform: "translate(-169.97 -328.3)",
    fill: "#566770"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M263.353,364.137c-1.6,2.011-6.259,5.169-9.744,7.232-1.171.692-2.866,1.644-4.84,2.7-3.539,1.9-7.975,4.136-11.884,5.83l-.006,0-.251.106a.68.68,0,0,1-.09.039c-.057.027-.115.052-.172.073l-.716.305c-.033.014-.066.026-.1.038a1.506,1.506,0,0,1-1.791-.446l-.154.5q-.6-1.115-1.22-2.183c.218-.212.637-.643,1.193-1.274.827-.936,11.193-5.727,11.468-5.882l.495-.28c9.524-5.4,11.389-7.336,12.573-7.791a1.549,1.549,0,0,1,.591-.115,11.339,11.339,0,0,1,4.252.58Z",
    transform: "translate(-170.39 -327.763)",
    fill: "#63747d"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M245.383,371.081l-.633-.307s-.02-3.158.316-3.572a105.8,105.8,0,0,1,10.172-5.317c.35.046,4.618,2.511,4.618,2.511Z",
    transform: "translate(-169.925 -327.805)",
    fill: "#63747d"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M239.441,357.558l-1.5.863a26.265,26.265,0,0,0-2.47,1.62h0a.957.957,0,0,0-.339.919l.186.87a.438.438,0,0,0,.613.368h0a23.2,23.2,0,0,0,2.544-1.274l1.5-.863a26.2,26.2,0,0,0,2.469-1.621h0a.954.954,0,0,0,.339-.918l-.186-.871a.438.438,0,0,0-.613-.369h0A23.492,23.492,0,0,0,239.441,357.558Z",
    transform: "translate(-170.287 -328.017)",
    fill: "#63747d"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M239.659,358.637c-.017-.427-.109-1.607-.109-1.607l-1.488.032s.166,1.672.184,1.733c.084.272.447.573.6.557C239.215,359.315,239.678,359.1,239.659,358.637Z",
    transform: "translate(-170.176 -327.987)",
    fill: "#63747d"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M239.425,356.7a.625.625,0,0,1-.208.926.8.8,0,0,1-1.031-.206.626.626,0,0,1,.208-.927A.8.8,0,0,1,239.425,356.7Z",
    transform: "translate(-170.176 -328.011)",
    fill: "#63747d"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M282.461,378.537c.267.967-6.111,6.033-8.11,7.527a78.535,78.535,0,0,1-7.063,4.452c-3.447,2.016-6.169,3.181-15.245,5.58-.627.166-1.895-1.772-1.895-1.772l27.383-17.312Z",
    transform: "translate(-169.722 -327.237)",
    fill: "#efeef0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M255.529,394.562c-2.854.281-4.469-.754-5.164-1.485s-1.088.767-1.088.767,1.813,3.113,3.31,3.113S255.529,394.562,255.529,394.562Z",
    transform: "translate(-169.755 -326.641)",
    fill: "#efeef0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M222.489,363.631s2.082,1.863,6.611,8.406a69.908,69.908,0,0,1,5.737,9.234l-1.662.119-6.112-10.185-5.687-7.18Z",
    transform: "translate(-170.803 -327.739)",
    fill: "#efeef0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M224.466,333.464c-7.5,3.125-8.711,3.615-13.507,6.407s-10.239,6.076-12.652,8.7c0,0-1.458-.1-3.574-.123a50.082,50.082,0,0,0-10.592.827,28.381,28.381,0,0,1,3.683-3.433,88.666,88.666,0,0,1,10.115-7.021,91.738,91.738,0,0,1,13.447-6.389,6.492,6.492,0,0,1,1.28-.37,3.919,3.919,0,0,1,1.358-.039S222.12,332.564,224.466,333.464Z",
    transform: "translate(-172.202 -328.928)",
    fill: "#37464e"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M174.8,346.982a8.331,8.331,0,0,1,2.3-3.076,96.845,96.845,0,0,1,10.355-7.209c6.983-4.34,13.021-7.18,14.645-7.535a7.447,7.447,0,0,1,3.319.169l-2.64,5.252Z",
    transform: "translate(-172.553 -329.039)",
    fill: "#efeef0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M249.142,374.235c-3.539,1.9-7.975,4.136-11.884,5.83l-.006,0-.251.106a.674.674,0,0,1-.09.039c-.057.027-.115.052-.172.073l-.716.305c-.033.015-.066.026-.1.038a1.506,1.506,0,0,1-1.791-.446l-.154.495A100.192,100.192,0,0,0,222.45,363.82s4.527-1.847,10.918-5.275a77.149,77.149,0,0,1,10.5,9.723C246.208,370.783,247.914,372.748,249.142,374.235Z",
    transform: "translate(-170.763 -327.93)",
    fill: "#1c2121",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M285.207,390.666a1.665,1.665,0,0,1,0,.338.652.652,0,0,1-.029.146c.035,1.9-2.282,4.084-4.919,5.846-.006-.274-.006-.432-.011-.524v-.129c.158-.222-.491-1.2-.642-1.156s-4.452,2.877-7.79,4.832-7.579,4.084-8.232,4.44c-.3.164-.671.169-.98.8s-.554,1.249-.624,1.423c-.012.03-.018.047-.018.047a1.9,1.9,0,0,1-.2.584,17.259,17.259,0,0,1-2.048.823c-4.177,1.267-5.922,1-5.922,1l.771-.52h.005l29.875-20.037a6.823,6.823,0,0,1,.747,1.984C285.195,390.6,285.2,390.637,285.207,390.666Z",
    transform: "translate(-169.585 -326.802)",
    fill: "#d2d3d4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M261.059,403.941a16.3,16.3,0,0,1-6.727,1.509,5.868,5.868,0,0,0,0,1.9,6.307,6.307,0,0,0,2.91-.294C259.43,406.518,260.793,406.008,261.059,403.941Z",
    transform: "translate(-169.567 -326.225)",
    fill: "#9099af"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M283.363,388.62c-.238,1.355-2.23,3.057-2.947,3.7a13.078,13.078,0,0,1,.048,2.217,11.287,11.287,0,0,0,2.693-2.906A8.1,8.1,0,0,0,283.363,388.62Z",
    transform: "translate(-168.585 -326.801)",
    fill: "#9099af"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M259.714,406.949a19.335,19.335,0,0,0,2.265-.922c-.012.03-.018.047-.018.047a1.9,1.9,0,0,1-.2.584,17.261,17.261,0,0,1-2.048.823c-4.177,1.267-5.922,1-5.922,1l.771-.52h.005A21.236,21.236,0,0,0,259.714,406.949Z",
    transform: "translate(-169.585 -326.147)",
    fill: "#9099af"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M284.25,390.6a1.678,1.678,0,0,1,0,.338.651.651,0,0,1-.029.146c.035,1.9-2.282,4.084-4.919,5.846-.006-.274-.006-.432-.011-.524,2.643-1.763,4.966-3.951,4.93-5.853.005-.018.005-.035.011-.053a.022.022,0,0,0,.005-.017A.8.8,0,0,1,284.25,390.6Z",
    transform: "translate(-168.628 -326.731)",
    fill: "#9099af"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M253.811,404.927a43.383,43.383,0,0,0,7.689-2.113,56.968,56.968,0,0,0,8-3.953c5.03-2.74,14.977-8.554,15.263-12.239a6.409,6.409,0,0,0-1.652-4.972l.387,3.17-.261,1.567-18.092,11.346L254.237,403.2Z",
    transform: "translate(-169.585 -327.062)",
    fill: "#e7e7e9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M254.222,403.187a43.382,43.382,0,0,0,7.688-2.114,57.122,57.122,0,0,0,8-3.954c5.029-2.739,14.446-8.239,14.731-11.925a5.817,5.817,0,0,0-1.271-3.249l-.545,4.675-3.983,2.473-15.9,9.387-7.322,3.192Z",
    transform: "translate(-169.569 -327.051)",
    fill: "#efeef0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M260.7,393.554s-3.546-3.012-7.472-5.759-11.955-7.55-11.955-7.55l.492-.236s7.183,4.386,10.927,6.743a79.828,79.828,0,0,1,7.643,5.654A2.5,2.5,0,0,1,260.7,393.554Z",
    transform: "translate(-170.056 -327.124)",
    fill: "#e7e7e9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M276.483,383.94s-13.915-14.238-14.946-15.069c.4.025,13.323,12.812,13.827,13.411A15.044,15.044,0,0,1,276.483,383.94Z",
    transform: "translate(-169.295 -327.542)",
    fill: "#e7e7e9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M191.713,348.463c1.909-1.517,3.994-3.146,5.665-4.271a124.31,124.31,0,0,1,18.15-9.939l-2.863-2.2a6.48,6.48,0,0,0-1.28.371,91.725,91.725,0,0,0-13.447,6.389,88.666,88.666,0,0,0-10.115,7.021,28.377,28.377,0,0,0-3.683,3.433c.13-.029.251-.054.369-.078A43.517,43.517,0,0,1,191.713,348.463Z",
    transform: "translate(-172.202 -328.925)",
    fill: "#63747d"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132",
    transform: "translate(35.007 37.788)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M206.669,382.352l-.295-.906.006-.021.663-2.476c-.01-.241-.164-4.092-.164-5.255,0-1.2.439-4.687.443-4.722l.83-3.513.146.034L207.471,369c0,.028-.44,3.506-.44,4.695s.162,5.22.163,5.26v.011l0,.01-.66,2.465.28.863Z",
    transform: "translate(-206.374 -365.459)",
    fill: "#9099af"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M233.841,381.9l-2.442-.3s-31.32-20.026-42.109-26.81c0,0,6.528-4.429,7-4.646s2.222,0,7.246,2.433a134.855,134.855,0,0,1,12.571,7.258,41.125,41.125,0,0,1,8.925,8.04C228.408,372.057,233.841,381.9,233.841,381.9Z",
    transform: "translate(-172.008 -328.248)",
    fill: "#292929"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M231.653,380.7c-2.442-1.561-29.631-18.942-40.768-25.963,2.3-1.551,5.16-3.47,5.692-3.778h.055c.446,0,1.969.235,6.452,2.408a133.307,133.307,0,0,1,12.46,7.194,39.436,39.436,0,0,1,8.726,7.857,116.533,116.533,0,0,1,7.844,12.338Z",
    transform: "translate(-171.948 -328.215)",
    fill: "#37464e"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M209.631,356.555s-2.7,5.531-2.7,9.193l3.321,2.151s-.226-7.4,1.208-10.115A15.591,15.591,0,0,0,209.631,356.555Z",
    transform: "translate(-171.346 -328.005)",
    fill: "#292929"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M230.455,380.392a2.113,2.113,0,0,0,.792-.272c.231-.189.059-.886-.335-1.136s-1.5.3-1.683.211-1.305.38-1.305.38l.364.8Z",
    transform: "translate(-170.557 -327.165)",
    fill: "#eeeef0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M228.371,377.536c1.042-.26,2.1.08,2.243,1.262.17,1.435-.461,1.663-.841,1.843a9.016,9.016,0,0,1-3.6.821c-1.8.021-2.023-.943-2.023-1.583,0-.092,0-.086.007-.171.051-.914.381-1.186.994-1.369C226.471,377.943,228.371,377.536,228.371,377.536Z",
    transform: "translate(-170.699 -327.22)",
    fill: "#eeeef0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M230.178,378.11a8.05,8.05,0,0,0-3.054.319c-1.216.265-2.131.244-2.228,1.427s.287,1.469.793,1.547a7.078,7.078,0,0,0,2.908-.35c1.443-.419,1.647-.656,1.872-1.054S230.773,378.3,230.178,378.11Z",
    transform: "translate(-170.671 -327.198)",
    fill: "#efeef0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M246.211,380.613l5.081-2.471c.2-.1.185-.289-.045-.425h0a.94.94,0,0,0-.788-.064l-5.08,2.47c-.205.1-.185.292.045.425h0A.931.931,0,0,0,246.211,380.613Z",
    transform: "translate(-169.907 -327.215)",
    fill: "#292929"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M257.69,374.537l4.159-3.1c.168-.125.135-.325-.073-.445h0a.672.672,0,0,0-.681.007l-4.16,3.1c-.168.127-.135.325.073.446h0A.674.674,0,0,0,257.69,374.537Z",
    transform: "translate(-169.471 -327.466)",
    fill: "#292929"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    transform: "translate(37.381 41.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M209.1,369.171a1.782,1.782,0,0,0-.386,1.5,15.589,15.589,0,0,0,3.444,2.32c.3.073.52-.751.477-1.005A39.561,39.561,0,0,0,209.1,369.171Z",
    transform: "translate(-208.661 -368.996)",
    fill: "#9099af"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(0.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M211.542,370.446l-2.034-1.293c-.264-.169-.488-.053-.5.257l0,.107a1.076,1.076,0,0,0,.452.864l2.8,1.78c.314.2.495-.14.29-.546h0A2.985,2.985,0,0,0,211.542,370.446Z",
    transform: "translate(-208.927 -368.999)",
    fill: "#d2d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M212.428,372.3a.4.4,0,0,1-.213-.072l-2.8-1.778a1.146,1.146,0,0,1-.488-.932l0-.107a.371.371,0,0,1,.617-.318l2.034,1.293a3.1,3.1,0,0,1,1.028,1.2.556.556,0,0,1-.012.649A.254.254,0,0,1,212.428,372.3Zm-3.146-3.145a.164.164,0,0,0-.081.019.268.268,0,0,0-.115.243l-.005.109a1.012,1.012,0,0,0,.418.8l2.8,1.778c.05.032.142.078.2.022s.088-.252-.022-.47a2.933,2.933,0,0,0-.974-1.139l-2.034-1.294A.369.369,0,0,0,209.282,369.154Z",
    transform: "translate(-208.929 -369.002)",
    fill: "#9099af"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M209.807,369.965c-.007.167-.128.229-.269.139a.578.578,0,0,1-.244-.465c.007-.166.128-.229.27-.139A.582.582,0,0,1,209.807,369.965Z",
    transform: "translate(-208.916 -368.985)",
    fill: "#292929"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(18.388 29.446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M190.793,357.588a1.78,1.78,0,0,0-.386,1.5,15.581,15.581,0,0,0,3.444,2.32c.3.073.52-.751.476-1.006A39.585,39.585,0,0,0,190.793,357.588Z",
    transform: "translate(-190.357 -357.412)",
    fill: "#9099af"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(0.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M193.237,358.863l-2.035-1.294c-.263-.168-.487-.052-.5.258l0,.107a1.076,1.076,0,0,0,.452.864l2.8,1.778c.314.2.5-.14.291-.546h0A2.99,2.99,0,0,0,193.237,358.863Z",
    transform: "translate(-190.622 -357.416)",
    fill: "#d2d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M194.123,360.715a.39.39,0,0,1-.213-.073l-2.8-1.777a1.147,1.147,0,0,1-.488-.932l.005-.108a.37.37,0,0,1,.616-.319l2.034,1.294a3.08,3.08,0,0,1,1.028,1.2.556.556,0,0,1-.012.649A.255.255,0,0,1,194.123,360.715Zm-3.146-3.145a.171.171,0,0,0-.081.018.27.27,0,0,0-.115.244l-.005.108a1,1,0,0,0,.418.8l2.8,1.778c.05.032.143.077.2.021s.089-.251-.021-.469a2.931,2.931,0,0,0-.975-1.14l-2.034-1.293A.359.359,0,0,0,190.977,357.571Z",
    transform: "translate(-190.624 -357.418)",
    fill: "#9099af"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M191.5,358.382c-.007.167-.128.229-.269.139a.577.577,0,0,1-.244-.465c.007-.167.128-.229.269-.139A.579.579,0,0,1,191.5,358.382Z",
    transform: "translate(-190.611 -357.401)",
    fill: "#292929"
  })))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M178.751,348.561s.141.805,3.614,1.58,15.978-1.65,15.978-1.65L183.875,349Z",
    transform: "translate(-172.404 -328.308)",
    fill: "#efeef0"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M251.372,402.96a9.175,9.175,0,0,0,5.707.5l2.867-.819-6.244,2.2-2.648-1.232Z",
    transform: "translate(-166.744 -326.274)",
    fill: "#d2d3d4"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M276.989,384.287c-6.12,4.541-16.8,9.845-16.8,9.845s-1.729,5.794,1.827,4.548,15.616-8.482,16.625-9.674A4.819,4.819,0,0,0,276.989,384.287Z",
    transform: "translate(-166.417 -326.963)",
    fill: "rgba(179,179,179,0.85)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M260.788,395.792s10.683-5.3,16.8-9.845a5.3,5.3,0,0,1,1.13,1.348,5.174,5.174,0,0,0-1.731-3.007c-6.12,4.541-16.8,9.845-16.8,9.845s-1.057,3.544.185,4.494A10.767,10.767,0,0,1,260.788,395.792Z",
    transform: "translate(-166.417 -326.963)",
    fill: "#b3b3b3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M260.6,393.776s-4.409,1.789-7,1.691a8.88,8.88,0,0,1-3.751-1.058.8.8,0,0,0-1.17.568l0,.029c-.037.365,0,1.483,0,1.483a8.232,8.232,0,0,0,3.416,1.757,12.061,12.061,0,0,0,6.285-.449c.948-.346,2.451,1.116,2.451,1.116l1.6-.588A10.764,10.764,0,0,0,260.6,393.776Z",
    transform: "translate(-166.834 -326.607)",
    fill: "#b3b3b3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M282.381,381.447c-.187,1.918-1.37,2.873-2.683,4.043a8.794,8.794,0,0,0-.279,2.656h0c-.251.2-.618.484-1.027.805-.14.1-.286.216-.432.327a20.766,20.766,0,0,0-1.594-4.78s1.446-1.214,3.256-2.953,2.013-2.485,2.013-2.485l-.1-.4C281.577,378.792,282.013,380.081,282.381,381.447Z",
    transform: "translate(-165.794 -327.175)",
    fill: "#b3b3b3"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M173.056,356.455s.239.72,2.7,2.469l2.465,1.751s-4.929-2.759-5.431-3.69Z",
    transform: "translate(-169.684 -328.009)",
    fill: "#9099af"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M229.809,386.542c-.19.963,1.629,3.131,2.031,2.4s.437-1.8,0-1.994S229.894,386.111,229.809,386.542Z",
    transform: "translate(-167.543 -326.884)",
    fill: "#1a1a1a"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M260.512,398.633a4.062,4.062,0,0,0-2.224-1.2,2.942,2.942,0,0,0-.718.146,8.97,8.97,0,0,1-3.164.362,8.257,8.257,0,0,1-2-.228,9.366,9.366,0,0,1-3.127-1.362c-.01-.418-.028-.811-.009-1.005a.2.2,0,0,1,.209-.167.228.228,0,0,1,.11.028,9.448,9.448,0,0,0,4,1.126c.076,0,.153,0,.23,0a22.228,22.228,0,0,0,6.736-1.678c.147-.072,10.631-5.349,16.721-9.87l-.155.052a25.273,25.273,0,0,0,3.466-3.05,15.95,15.95,0,0,0,1.45-1.565c.1.336.21.707.313,1.087a4.723,4.723,0,0,1-1.847,2.564,3.673,3.673,0,0,0-.768.793,8,8,0,0,0-.357,2.936l-.49.385a18.625,18.625,0,0,0-.646-2.066l-.049-.13-.1-.094c-.119-.11-.2-.173-.2-.173l-.352-.283-.364.267c-5.463,4.056-14.13,8.487-15.912,9.385l-1.127.565.237.513a11.643,11.643,0,0,1,.783,2.421Z",
    transform: "translate(-166.812 -327.116)",
    fill: "#f0f0f0"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(26.006 18.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M224.009,364.91l-.59-.6c-.009-.018-1-1.845-6.206-5.41-4.28-2.928-14.731-9.843-19.324-10.8-2.715-.568-3.029-.931-3.029-1.154,0-.249.427-.352.514-.369l.031.147c-.166.035-.393.131-.393.222s.21.443,2.907,1.007c4.619.964,15.09,7.892,19.379,10.825,5.1,3.492,6.158,5.286,6.249,5.454l.57.58Z",
    transform: "translate(-194.861 -346.57)",
    fill: "#9099af"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    transform: "translate(53.612 4.361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M249.6,349.706c-1.317-1.719-5.083-4.711-9.159-7.275-3.771-2.372-14.826-8.715-17.385-8.939a12.683,12.683,0,0,0-1.5-.1l-.022-.072-.051.058-.019-.087c.026-.061.038-.09,1.6.048,2.622.231,13.547,6.506,17.452,8.963,4.089,2.573,7.872,5.58,9.2,7.312Z",
    transform: "translate(-221.468 -333.242)",
    fill: "#9099af"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(24.948 6.863)",
    fill: "#fff"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    d: "M33.51,0A33.51,33.51,0,0,1,67.02,33.51c0,18.507-31.233,69.821-33.51,71.135S0,52.017,0,33.51A33.51,33.51,0,0,1,33.51,0Z",
    transform: "translate(20.38)",
    fill: "#16b1ef"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_31-2",
    "data-name": "Ellipse 31",
    cx: 19.401,
    cy: 19.401,
    rx: 19.401,
    ry: 19.401,
    transform: "translate(34.489 14.11)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoactioncar);
export default __webpack_public_path__ + "static/media/loactioncar.f4833f79bc36fa3c7b8aa4c60cf1515c.svg";
export { ForwardRef as ReactComponent };